import { autoBind } from "src/shared/decorators/autobind";
import { injectable } from "tsyringe";
import { OtpFlowData } from "src/containers/otp/types";

@injectable()
export class OtpService {
    public static readonly KEY_GOING_OTP = "GOING_TO_OTP";
    public static readonly KEY_FLOW_DATA = "OTP_FLOW_DATA";

    @autoBind
    setData(value: string | OtpFlowData) {
        let content: string = value as string;
        if (typeof value === "object") {
            content = JSON.stringify(content);
        }
        localStorage.setItem(OtpService.KEY_FLOW_DATA, content);
    }

    @autoBind
    getData(): OtpFlowData | null {
        const data = JSON.parse(
            localStorage.getItem(OtpService.KEY_FLOW_DATA) ?? "null"
        );
        return data ? (data as unknown as OtpFlowData) : null;
    }

    @autoBind
    removeData() {
        localStorage.removeItem(OtpService.KEY_FLOW_DATA);
    }
}
